import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { PropertySearchService } from './property-search.service';

import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';

import { PropertyListItem } from '../property';

import { PropertySearchResultsComponent } from './property-search-results/property-search-results.component';

function cleanupSearchParams(scrit) {
  let params = {}, val;
  for (let key in scrit) {
    val = scrit[key];
    if (val !== null && val.length > 0) params[key] = val;
  }
  return params;
}

@Component({
  selector: 'app-property-search',
  templateUrl: './property-search.component.html',
  styleUrls: ['./property-search.component.scss']
})
export class PropertySearchComponent implements OnInit {
  @Input() paginate: boolean = false;
  @Input() lazyLoad: boolean = false;
  @Input() autoSearch: boolean = false;

  /* show the search form */
  @Input() showform: boolean = false;

  /* colon delimited path in cfvars to search params */
  @Input() autosearchCriteriaPath: string;

  /* default page size */
  @Input() rows: number = 10;

  @Input() get value() { return this._properties; }

  set value(val: PropertyListItem[]) { this._properties = val; }

  api = (<any>_GlobalNS).api.property.search;

  /* private properties */
  _properties: PropertyListItem[] = [];

  /* public properties */
  properties: PropertyListItem[] = [];

  searchParams: object = {};
  searchCriteria: object = {};

  searchResponse: {};

  constructor(
    private _searchSvc: PropertySearchService,
    private _globalSvc: GlobalService
  ) { }

  @ViewChild(PropertySearchResultsComponent)
  private resultsComponent: PropertySearchResultsComponent;

  ngOnInit() {

    console.log(`PropertySearch Component::INITED`, this.autosearchCriteriaPath);


    /**
     * check attributes
     * These just need to exist to be considered true
     */
    // if(this.paginate    !== undefined) this.paginate = true;
    // if(this.lazyload    !== undefined) this.lazyload = true;
    // if(this.autosearch  !== undefined) this.autosearch = true;


    console.log(`Attributes: `,
      this.paginate,
      this.lazyLoad,
      this.autoSearch,
      this.autosearchCriteriaPath
    );

    /**
     * autosearch triggers search on page load
     */
    if (this.autoSearch) {
      this.searchCriteria = this._globalSvc.find(this.autosearchCriteriaPath);

      /* remove any nulls */
      if (this.autosearchCriteriaPath) {
        (<any>this).searchParams = cleanupSearchParams(this.searchCriteria);
      }

      console.log(`Autosearching`, this.api, this.searchParams);
      this.resultsComponent.loading = true;
      this._searchSvc
        .search(this.api, this.searchParams)
        .subscribe(res => {
          this._properties = (<any>res).data;

          this.properties = this._properties;

          this.resultsComponent.loading = false;
          // this.resultsComponent.properties = this._properties;

          // update property search results component
          this.resultsComponent.pagination = (<any>res).meta.pagination;
          this.resultsComponent.totalRecords = (<any>res).meta.pagination.TotalRecords;
          this.resultsComponent.searchCriteria = this.searchParams;
        });

    }
  }

  loadData = (event) => {
    this.searchCriteria = this._globalSvc.find(this.autosearchCriteriaPath);
    (<any>this).searchParams = cleanupSearchParams(this.searchCriteria);
    (<any>this).searchParams.Offset = event.first;
    (<any>this).searchParams.PageSize = event.rows;
    this._searchSvc
      .search(this.api, this.searchParams)
      .subscribe(res => {
        this._properties = (<any>res).data;

        this.properties = this._properties;

        this.resultsComponent.loading = false;

        // update property search results component
        this.resultsComponent.pagination = (<any>res).meta.pagination;
        this.resultsComponent.totalRecords = (<any>res).meta.pagination.TotalRecords;
        this.resultsComponent.searchCriteria = this.searchParams;
      });
  }
}
